export const soaSubdomainValidator = (value) => {
    // SOA запись только для корневого домена (@) или пустая
    return (value === "" || value === "@") ? true : "validate.soa_subdomain_only_root";
}; 